import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);

export default class DetailsAnim {
  constructor(section) {
    this.section = section;
		this.title = this.section.querySelector(".section-title");
		this.detailsBtn = this.section.querySelector(".fp-btn-ter");	
		this.text = this.section.querySelector(".more-info");
		this.swiperEl = this.section.querySelector('.detailsSlider');
		this.navButtons = this.section.querySelector('.swiper-navigation');
		
		this.init();
  }

  init() {

		this.swiper = new Swiper(this.swiperEl, {
			modules: [Autoplay, Navigation],
			speed: 600,
			slidesPerView: 1.5,
			spaceBetween: 16,
			loop: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true
			},
			navigation: {
				nextEl: '.swiper-navigation .next',
				prevEl: '.swiper-navigation .prev',
			},
			breakpoints: {
				768: {
					slidesPerView: 2.5,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 4.45,
					spaceBetween: 24,
				}
			},
		});

		// Nascondi gli elementi all'inizio
		gsap.set([this.title, this.text, this.detailsBtn], {autoAlpha: 0});
		gsap.set(this.swiperEl, {visibility: 'hidden', opacity: 0});

		document.fonts.ready.then(() => {
			this.titleSplit = SplitText.create(this.title, {type: "lines", autoSplit: true, mask: "lines", aria: "none" });
			this.textSplit = SplitText.create(this.text, {type: "lines", autoSplit: true, mask: "lines", aria: "none" });

			this.tl = gsap.timeline({ 
				scrollTrigger: {
					trigger: this.section,
					start: "top 60%",
					once: true,
				},
				defaults: {ease: "expo.out", force3D: true},
				onComplete: () => {
					this.titleSplit.revert();
					this.textSplit.revert();
				}
			});

			this.tl
				.set([this.title, this.text], {autoAlpha: 1}, 0)
				.from(this.titleSplit.lines, { yPercent: 50, autoAlpha: 0, duration: 1.5, stagger: 0.1 }, 0)
				.to([this.detailsBtn], {autoAlpha: 1, duration: 1.5 }, "<10%")
				.from(this.textSplit.lines, { yPercent: 100, autoAlpha: 0, duration: 1.4, stagger: 0.1 }, "<5%")
				.to(this.swiperEl, {visibility: 'visible', opacity: 1, duration: 1.2, ease: "power3.inOut"}, "<")
				.to(this.navButtons, {opacity: 1, duration: 1}, 1.5)
		});

		return this.tl;
  }
}
